import { FC } from "react";
import { UserAccountPreferencesView } from "../../../../modules/preferences/views/user-account-preferences-view/UserAccountPreferencesView";

export const UserAccountPreferencesRoute: FC = () => {
    return (
        <UserAccountPreferencesView />
    )
}